module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "container mainContent"
  }, [_m(0), " ", _m(1), " ", _m(2), " ", _m(3), " ", _m(4), " ", _m(5), " ", _m(6), " ", _m(7), _m(8), " ", _m(9), " ", _h('iframe', {
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.773802024184!2d18.502809315210943!3d-33.89547898064882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc5c112ae309a3%3A0x2e84748d4b1c112!2sCentury+City+Conference+Centre!5e0!3m2!1sen!2sza!4v1478123605580",
      "width": "1170",
      "height": "600",
      "frameborder": "0",
      "style": "border:0",
      "allowfullscreen": ""
    }
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('h2', ["Venue Information"])
}},function (){with(this) {
  return _h('h3', ["Address & Contact Details"])
}},function (){with(this) {
  return _h('p', [_h('a', {
    attrs: {
      "href": "http://www.ccconferencecentre.co.za"
    }
  }, [_h('strong', ["Century City Conference Centre and Hotel"])])])
}},function (){with(this) {
  return _h('address', ["\n    No. 4 Energy Lane", _h('br'), "\n    Bridgeways Precinct", _h('br'), "\n    Century City", _h('br'), "\n    7441\n  "])
}},function (){with(this) {
  return _h('p', ["\n    Tel nr: ", _h('a', {
    attrs: {
      "href": "tel:+27212048000"
    }
  }, ["+27 21 204 8000"])])
}},function (){with(this) {
  return _h('p', ["\n    Website: ", _h('a', {
    attrs: {
      "href": "http://www.ccconferencecentre.co.za"
    }
  }, ["http://www.ccconferencecentre.co.za"])])
}},function (){with(this) {
  return _h('h3', ["Site Map"])
}},function (){with(this) {
  return _h('img', {
    attrs: {
      "src": require("../assets/img/venue-map.jpg")
    }
  })
}},function (){with(this) {
  return _h('br')
}},function (){with(this) {
  return _h('h3', ["Directions"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info_venue.vue
 ** module id = 90
 ** module chunks = 2
 **/